import Image from '@/components/image';
import NextLink from '@/components/next-link';

const BrandCard = ({ url, img, target = '_self', name }) => {
  return (
    <NextLink
      target={target}
      href={url}
      className='flex flex-col items-center gap-1 rounded-[10px] bg-[#F2F3F5] px-2.5 pt-[7px] pb-2'
    >
      <Image
        src={img}
        alt={name + ' brand'}
        className='h-22.5 w-[81px] rounded-full sm:w-[85px] md:size-[95px] lg:size-[103px]'
      />
      <p className='line-clamp-1 text-center text-xs font-bold sm:text-[13px] md:text-[13.5px] lg:text-sm'>
        {name}
      </p>
    </NextLink>
  );
};

export default BrandCard;
